module.exports = __webpack_public_path__ + "5a8d956e803c1673335dbdb423da952f.MP3";